<template>
    <el-dialog :visible.sync="show" :title="question.caption" append-to-body>
        <el-table class="w-100 mb-2" :data="commentList" :empty-text="$t('No comment found')">
            <template v-if="!$client.isMobile">
                <el-table-column :label="$t('Comment')" resizable>
                    <template slot-scope="scope">{{ scope.row.data_comment }}</template>
                </el-table-column>
                <el-table-column :label="$t('Reviewer')" width="150" resizable>
                    <template slot-scope="scope">{{ scope.row.reviewer.fullName }}</template>
                </el-table-column>
                <el-table-column :label="$t('Date')" width="150" resizable>
                    <template slot-scope="scope">{{
                        moment(scope.row.record_date_utc).format(
                            $store.getters.momentDateTimeDisplayFormat
                        )
                    }}</template>
                </el-table-column>
            </template>
        </el-table>

        <el-form
            label-width="120px"
            label-position="top"
            :model="formQuestionDataComment"
            :rules="formQuestionDataFormRules"
            ref="formQuestionDataForm"
        >
            <el-form-item :label="$t('Comments')" prop="data_comment">
                <el-input
                    type="textarea"
                    :rows="3"
                    v-model="formQuestionDataComment.data_comment"
                ></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onSaveComment" type="primary" size="small">{{
                $t('Add Comment')
            }}</el-button>
            <el-button type="text" @click="onCancel" size="small">{{ $t('Close') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Collection from '@/lib/data/Collection';
import FormQuestion from '@/data/FormQuestion';
import FormQuestionDataComment from '@/data/FormQuestionDataComment';
import moment from 'moment';

export default {
    name: 'questioncomment',
    components: {},
    props: {
        value: Boolean,
        question: { type: FormQuestion, required: true },
    },
    data() {
        return {
            formQuestionDataComment: new FormQuestionDataComment(),
            commentList: new Collection({
                model: FormQuestionDataComment,
                url: '/visit/commentlist',
                method: 'GET',
            }),
            formQuestionDataFormRules: {
                data_comment: [
                    {
                        required: true,
                        message: this.$t('Please enter comment'),
                        trigger: 'change',
                    },
                ],
            },
            moment,
        };
    },
    created() {
        this.getComments();
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        context() {
            return this.$store.getters.context;
        },
        user() {
            return this.$store.getters.user;
        },
    },
    watch: {
        'question.data.id': function (v) {
            if (v) {
                this.getComments();
            }
        },
    },
    methods: {
        getComments() {
            this.commentList.load(true, {
                params: {
                    form_ques_data_id: this.question.data.id,
                },
            });
        },
        onCloseCommentDialog() {
            this.commentDialogVisible = false;
        },
        onSaveComment() {
            this.$refs.formQuestionDataForm.validate((valid) => {
                if (valid) {
                    this.formQuestionDataComment.form_ques_data_id = this.question.data.id;

                    this.formQuestionDataComment.create({
                        success: (op, response) => {
                            this.show = false;
                            this.question.data.comments = (
                                this.question.data.comments || []
                            ).concat([response.data]);

                            this.$notify.success({
                                title: this.$t('Success'),
                                message: this.$t('Comment added successfully.'),
                            });
                        },
                        failure: (op, response) => {
                            this.$notify.error({
                                title: this.$t('Error'),
                                message:
                                    response && response.meta
                                        ? response.meta.display_message
                                        : this.$t('Errors occured, please try again later'),
                            });
                        },
                    });
                }
            });
        },
        onCancel() {
            this.formQuestionDataComment.reject();
            this.show = false;
            this.$emit('cancel', this.formQuestionDataComment);
        },
    },
};
</script>

<style lang="scss"></style>
